import axios from 'axios';
import { BASE_URL } from '../Constants/Api';

const API_URL = BASE_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const fetchExecutives = async (page = 0, size = 10, filters = {}) => {
    const params = {
        page,
        size,
        ...filters
    };
    
    console.log('User API Request URL:', `/user`);
    console.log('User API Request Params:', params);
    
    const response = await api.get("/user", { params });
    
    console.log('User API Response:', response.data);
    
    return response.data;
};

export const addUser = async (userData) => {
    const response = await api.post("/user", userData);
    return response.data;
};

// Add this for Edit Employee integration
export const getUserById = async (id) => {
    const response = await api.get(`/user/${id}`);
    return response.data;
};

export const editUser = async (id, userData) => {
    const response = await api.put(`/user/${id}`, userData);
    return response.data;
};

export const updatePassword = async (passwordData) => {
    const response = await api.put("/user/update", passwordData);
    return response.data;
};